import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule } from '@angular/material/legacy-select';

@Component({
    selector: 'nova-pagination',
    templateUrl: './pagination.component.html',
    standalone: true,
    imports: [MatLegacyFormFieldModule, MatLegacyButtonModule, MatIconModule, MatLegacySelectModule]
})
export class PaginationComponent {
    pages: number[] = [];
    @Input() currentPage = 1;
    get pageCount() {
        return this.pages.length;
    }

    @Input() set pageCount(value: number) {
        if (value > 0 && value !== this.pageCount) {
            this.pages = [];
            for (let i = 1; i <= value; i++) {
                this.pages.push(i);
            }
        }
    }

    @Output() onPageSelected = new EventEmitter<number>();

    loadPage(pageNumber: number) {
        if (pageNumber <= this.pageCount && pageNumber >= 1) {
            this.currentPage = pageNumber;
            this.onPageSelected.emit(this.currentPage);
        }
    }
}
